var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowerf75D2B2E1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 210,
    viewBox: "0 0 177 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flower.f75d2b2e 1",
    clipPath: "url(#clip0_53_2683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.748 140.086C39.7291 117.189 18.6248 90.7607 17.171 74.6209C15.2999 53.4617 29.8291 36.1833 44.8495 38.1054C57.8917 39.7774 55.4541 100.08 55.2063 106.838C54.3731 130.092 48.7733 143.21 42.3669 155.082C49.3384 146.272 55.7229 138.141 60.6325 131.878C76.6816 111.43 81.2913 104.407 82.5933 102.161C82.1943 100.171 81.76 97.9193 81.4605 96.6502C78.8795 85.8542 68.8046 67.1466 67.3948 53.4216C65.3704 33.3871 77.9476 21.9318 89.7272 23.5903C102.022 25.3181 106.429 49.1883 104.187 67.3388C101.945 85.4894 89.2595 94.073 83.2604 105.584C82.1023 107.887 76.4757 115.569 68.451 126.047C78.5777 117.578 91.5309 113.252 104.718 113.962C122.192 114.344 139.731 111.723 147.268 120.244C154.805 128.765 138.863 138.325 124.185 142.123C111.074 145.468 74.0355 128.819 63.9675 131.901C53.045 146.054 38.9996 163.821 25.8088 180.285C35.1637 173.911 34.1094 171.842 54.5134 167.111C66.6327 164.318 98.1352 174.627 96.5512 182.222C94.9671 189.817 82.4693 196.116 67.7712 195.588C55.9176 195.163 40.0239 181.875 33.3641 182.197C31.8322 182.277 26.4013 183.009 23.2684 183.43C7.17375 203.499 -7.21172 221.089 -12.3734 226.866L-13.9647 225.643C-12.6154 224.179 -4.41554 213.975 6.38743 200.423C8.42037 190.102 -14.2476 164.174 -16.1642 150.089C-18.1742 135.354 -16.7309 121.314 -8.10298 118.303C-0.898766 115.803 17.146 142.437 19.9351 158.885C21.75 169.784 20.749 178.97 15.9182 188.42C23.2553 179.173 31.121 169.241 38.55 159.858C38.522 155.949 38.4752 146.95 38.748 140.086Z",
    fill: "#0074BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_2683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 210,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerf75D2B2E1);
export default __webpack_public_path__ + "static/media/flower.f75d2b2e 1.078dc51f7c9ae1ee79592369c8711eca.svg";
export { ForwardRef as ReactComponent };